import type { QueryClient } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { seedViewerLocationFact } from "../location-fact";
import { readVercelGeoLocation } from "../vercel-geo";

export type InitialGeoLocation = {
    lat: number;
    lng: number;
};

export type InitialGeoContext = {
    initialGeo?: InitialGeoLocation | null;
    queryClient: QueryClient;
};

export const getInitialGeoLocation = createServerFn({ method: "GET" })
    .inputValidator(() => undefined)
    .handler(async (): Promise<InitialGeoLocation | null> => {
        const location = readVercelGeoLocation(getRequest());
        if (!location) return null;

        await seedViewerLocationFact(
            {
                city: location.city,
                state: location.countryRegion,
                lat: location.latitude,
                lng: location.longitude,
            },
            "vercel",
        );

        return {
            lat: location.latitude,
            lng: location.longitude,
        };
    });
